// extracted by mini-css-extract-plugin
export default {"button":"SpeakButton_button__jkWfv","icon":"SpeakButton_icon__TBEx7"};